import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row-stretch" }
const _hoisted_2 = { class: "w-full mtop-04" }

import { ref, computed, onMounted, nextTick } from 'vue'
import gen from "@/functions/general.js"


export default /*@__PURE__*/_defineComponent({
  __name: 'inputComboBox',
  props: {
  values: {       //An array of objects
    type: Array,
    required: true,
  },
  initialSugg: {
    type: Array,
    required: true,
  },
  textKey: {      //The key of the object to use for displaying in the UI
    type: String,
    required: true,
  },
  searchKey: {    //The key of the object to use for searching. If empty, the textKey will be used
    type: String,
    default: "",
  },  
  max: {          //The max number of onjects to display
    type: Number,
    default: 5,
  },
  searchInsideString: {   //Boolean to decide if looking only at the beginning of a string, or also inside
    type: Boolean,
    default: false,
  },

},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const props = __props

const emits = __emit
const filterStr = ref("")
const showDropdown = ref(false)
const focusRef = ref(null)

// function inputFct(event) {
//   filterStr.value = event.target.value
//   console.log(event.target.value)
// }

function clearFCT() {
  filterStr.value = ''
  focusRef.value.$el.focus()
}

function selectFct(item) {
  filterStr.value = item[props.searchKey]
  
  emits ('close', item)
  showDropdown.value = false
}

function hideDropdown() {
  setTimeout(() => {
    showDropdown.value = false
  }, 150)
}

const sugg = computed(() => {
  const sKey = props.searchKey || props.textKey
  if (! filterStr.value && props.initialSugg) {
    return props.initialSugg
  } else if ( filterStr.value && props.initialSugg && !props.values) {
    return props.initialSugg
  } else {        
    if (props.values) {
      let sugg = gen.deepCopy(props.values)
      if (props.searchInsideString) {
        sugg = sugg.filter(item => {
          return item[sKey].toUpperCase().search(filterStr.value.toUpperCase()) > -1
        })
      } else {
        sugg = sugg.filter(item => {
          return item[sKey].toUpperCase().startsWith(filterStr.value.toUpperCase())
        })
      }
      return sugg.slice(0, props.max)
    }
    else {
      return []
    }
  }
})

onMounted(() => {
  nextTick(() => {
    focusRef.value.$el.focus()
  })
})


return (_ctx: any,_cache: any) => {
  const _component_inputLineNew2 = _resolveComponent("inputLineNew2")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_listGroup = _resolveComponent("listGroup")!
  const _component_inputBox = _resolveComponent("inputBox")!

  return (_openBlock(), _createBlock(_component_inputBox, {
    style: {"min-width":"5rem","position":"relative"},
    styles: "pad-s"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_inputLineNew2, {
          ref_key: "focusRef",
          ref: focusRef,
          modelValue: filterStr.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterStr).value = $event)),
          onFocus: _cache[1] || (_cache[1] = ($event: any) => (showDropdown.value = true)),
          onBlur: _cache[2] || (_cache[2] = ($event: any) => (hideDropdown()))
        }, null, 8, ["modelValue"]),
        (filterStr.value)
          ? (_openBlock(), _createBlock(_component_buttonGroup, {
              key: 0,
              theme: "inline",
              onClick: clearFCT
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_item, {
                  icon: "x",
                  styles: "size-l main-l pad-m"
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      (sugg.value.length > 0 && showDropdown.value == true)
        ? (_openBlock(), _createBlock(_component_inputBox, {
            key: 0,
            style: {"position":"absolute","margin-left":"-0.2rem","margin-top":"0.2rem"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sugg.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_listGroup, {
                    key: index,
                    styles: "pad-s",
                    class: "pleft-08",
                    onClick: ($event: any) => (selectFct(item))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: item[__props.textKey],
                        class: "linebreak"
                      }, null, 8, ["txt"])
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})